import styled from 'styled-components';
import background from '../../../../assets/img/background.png';

export const Container = styled.div`
  position: relative;
  width: 100%;

  overflow: hidden;

  /* border-bottom: 3px solid var(--purple93);
  box-shadow: inset 0 3px 6px var(--purple93); */

  &:before {
    content: '';

    position: absolute;
    z-index: -1;
    inset: 0;

    transform: rotate(10deg) scale(2);

    opacity: 0.9;
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    min-height: 500px;
  }

  .content {
    margin: 0 auto;
    padding: 3em 0;
  }

  h1 {
    font-family: 'Montserrat', sans-serif;
    font-size: 4rem;
    font-weight: bold;
    color: white;

    margin-bottom: unset;
  }
`;

export const GradientBackground = styled.div`
  position: absolute;
  bottom: -60px;
  width: 100%;
  height: 140px;
  z-index: -1;
  background: linear-gradient(
    0deg,
    var(--green2c) -100%,
    rgba(255, 255, 255, 1) 70%,
    rgba(255, 255, 255, 1) 80%
  );
`;
